module.exports = __webpack_public_path__ + "media/images/pic/hero/courses/school/school-03d2d0b5a2fd300e26c7e1193a292f06.jpeg";